import axios from 'axios';
import { LOGOUT, SUBSCRIPTION } from '../store/constants';
import { LOCAL_STORAGE_ACCESS_TOKEN, LOCAL_STORAGE_REFRESH_TOKEN } from '../utils/constants';
import { setOpenSubscriptionModal } from '../store/slice/vendor/slice';

// const BASE_URL = 'http://localhost:5000';
const BASE_URL = 'https://api.ringleader.cloud';
let store;

export const injectStore = _store => {
  store = _store;
};

const API_BASE_URL = `${BASE_URL}/api/`;
const AUTH_BASE_URL = `${BASE_URL}/auth/`;

const axiosAuthClient = axios.create({
  baseURL: AUTH_BASE_URL,
});

const axiosApiClient = axios.create({
  baseURL: API_BASE_URL,
});

axiosApiClient.interceptors.request.use(
  config => {
    const token = localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN);
    config.headers = {
      Authorization: `Bearer ${token}`,
      version: '2.0.0',
    };
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

axiosAuthClient.interceptors.request.use(
  config => {
    config.headers = {
      version: '2.0.0',
    };
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

axiosApiClient.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    try {
      const originalRequest = error.config;
      let currentRefreshToken = localStorage.getItem(LOCAL_STORAGE_REFRESH_TOKEN);
      if (currentRefreshToken && error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        const refreshResponse = await axiosAuthClient.post('/refresh-token', {
          refreshToken: currentRefreshToken,
        });
        if (refreshResponse.status !== 200) {
          return Promise.reject(error);
        }
        const { accessToken, refreshToken } = refreshResponse.data.data;

        localStorage.setItem(LOCAL_STORAGE_ACCESS_TOKEN, accessToken);
        localStorage.setItem(LOCAL_STORAGE_REFRESH_TOKEN, refreshToken);
        originalRequest.headers['Authorization'] = `Bearer ${accessToken}`;
        return axios(originalRequest);
      } else if (error.response.status === 401) {
        localStorage.removeItem(LOCAL_STORAGE_ACCESS_TOKEN);
        localStorage.removeItem(LOCAL_STORAGE_REFRESH_TOKEN);

        store.dispatch({ type: LOGOUT });
      } else if (error.response.status === 405) {
        store.dispatch({ type: SUBSCRIPTION });
      }

      return Promise.reject(error);
    } catch (err) {
      if (error.response.status === 405) {
        store.dispatch({ type: SUBSCRIPTION });
      } else if (err.response.status === 400) {
        localStorage.removeItem(LOCAL_STORAGE_ACCESS_TOKEN);
        localStorage.removeItem(LOCAL_STORAGE_REFRESH_TOKEN);

        store.dispatch({ type: LOGOUT });
      }
      return Promise.reject(err);
    }
  },
);

export default axiosApiClient;
export { axiosAuthClient };
